module.exports = " <div role=tabpanel class=tab-pane v-bind:class={hide:!show} v-show=show :transition=transition _v-3c2dc0ee=\"\"> <slot _v-3c2dc0ee=\"\"></slot> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/_vue-html-loader@1.2.4@vue-html-loader!./~/_vue-loader@8.3.1@vue-loader/lib/template-rewriter.js?id=_v-3c2dc0ee!./~/_vue-loader@8.3.1@vue-loader/lib/selector.js?type=template&index=0!./bootsets/components/vue-strap/Tab.vue
// module id = 273
// module chunks = 0